import _ from 'lodash';
import { useLayoutEffect, useState } from 'react';

/**
 * It tries iteratievely to reduce the font-size of the given container
 * until it stops being bigger than it's parent content size.
 */
export function useAutoFontSize(container: HTMLElement | null) {
  const [renderIdx, rerender] = useState(0);

  useLayoutEffect(() => {
    if (!container) return;

    if (!container.offsetHeight) {
      // Element is hidden. Let's wait until it's shown.
      const ro = new ResizeObserver(() => {
        if (container.offsetHeight) {
          rerender(prev => prev + 1);
        }
      });
      ro.observe(container);
      return () => ro.disconnect();
    }

    let dec = 0;
    while (isBiggerThanParent(container)) {
      dec = _.round(dec + STEP, 2);
      container.style.setProperty('--dec', dec + UNIT);
      if (dec > MAX_DEC) break;
    }
  }, [renderIdx, container]);
}

function isBiggerThanParent(container: HTMLElement): boolean {
  const parent = container.parentElement;
  if (!(parent instanceof HTMLElement)) {
    return false;
  }

  const styles = window.getComputedStyle(parent);
  const pTop = parseInt(styles.paddingTop);
  const pBottom = parseInt(styles.paddingBottom);
  if (typeof pTop !== 'number' || typeof pBottom !== 'number') {
    throw new Error(`Couldn't calculate the parent container's paddings`);
  }

  const parentBodyH = parent.clientHeight - pTop - pBottom;
  return parentBodyH < container.offsetHeight;
}

const MAX_DEC = 1.5;
const STEP = 0.1;
const UNIT = 'rem';
